/**
 * @flow weak
 */


// Consts
export const ON_PAYMENT_PLAN_MOUNT = 'ON_PAYMENT_PLAN_MOUNT';
export const ON_PAYMENT_PLAN_MOUNT_SUCCESS = 'ON_PAYMENT_PLAN_MOUNT_SUCCESS';
export const ON_PAYMENT_PLAN_MOUNT_ERROR = 'ON_PAYMENT_PLAN_MOUNT_ERROR';
export const PAY_INSTALLMENT = 'PAY_INSTALLMENT';
export const PAY_INSTALLMENT_SUCCESS = 'PAY_INSTALLMENT_SUCCESS';
export const PAY_INSTALLMENT_ERROR = 'PAY_INSTALLMENT_ERROR';
export const PAY_INSTALLMENTS = 'PAY_INSTALLMENTS';
export const PAY_INSTALLMENTS_SUCCESS = 'PAY_INSTALLMENTS_SUCCESS';
export const PAY_INSTALLMENTS_ERROR = 'PAY_INSTALLMENTS_ERROR';

// Actions
export const onPaymentPlanMount = (id) => {
  return {
    type: ON_PAYMENT_PLAN_MOUNT,
    payload: {
      id
    }
  };
};

export const payInstallment = (number) => {
  return {
    type: PAY_INSTALLMENT,
    payload: {
      number
    }
  };
};

export const payAllInstallments = () => {
  return {
    type: PAY_INSTALLMENTS
  };
};



// WEBPACK FOOTER //
// ./src/modules/payment-plans/actions.js